import React from "react";

export const LogoSizeField = ({ value, onChange, min, max, testId, logoSrc, mode = "height" }) => {
  const clamp = (n) => Math.max(min, Math.min(max, Number(n) || min));
  // mode "height" (default) previews by height — used by the nav/footer
  // HEIGHT settings. mode "width" previews by width — used by the
  // footer logo WIDTH settings where height always stays auto.
  const previewStyle = mode === "width" ? { width: `${value}px` } : { height: `${value}px` };
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-4">
        <input
          type="range"
          min={min}
          max={max}
          step={1}
          value={value}
          onChange={(e) => onChange(clamp(e.target.value))}
          data-testid={`${testId}-range`}
          className="flex-1 accent-[#FF6600]"
        />
        <div className="flex items-center gap-2">
          <input
            type="number"
            min={min}
            max={max}
            value={value}
            onChange={(e) => onChange(clamp(e.target.value))}
            data-testid={testId}
            className="w-20 bg-[#1A1A1A] border border-[#262626] rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-[#FF6600]"
          />
          <span className="text-xs text-[#A3A3A3]">px</span>
        </div>
      </div>
      <div className="bg-[#0F0F0F] border border-[#262626] rounded-xl px-4 py-4 flex items-center gap-3">
        <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#5A5A5A] shrink-0">Preview</span>
        <div className="flex items-center h-20">
          {logoSrc ? (
            <img
              src={logoSrc}
              alt="Logo preview"
              data-testid={`${testId}-preview-img`}
              style={previewStyle}
              className={`object-contain ${mode === "width" ? "h-auto" : "w-auto"}`}
            />
          ) : (
            <div
              data-testid={`${testId}-preview-placeholder`}
              style={previewStyle}
              className="w-auto aspect-[3/1] bg-gradient-to-r from-[#FF6600] to-[#FF9D40] rounded-md grid place-items-center px-3 text-white font-display font-black"
            >
              UD.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
